import React from 'react';

class Checkbox extends React.Component {

    handleChange(event) {
        this.props.handleChange(event.target.checked);
    }

    render() {
        return (
            <div className="form-group">
                <div className="checkbox">
                    <label>
                        <input name={this.props.item.name} type="checkbox" defaultChecked={this.props.value} onChange={(event) => this.handleChange(event)}/> {this.props.item.title}
                    </label>
                </div>
            </div>
        );
    }
}

Checkbox.defaultProps = {
    value : false
}

export default Checkbox;